import React, { Component } from 'react';
import { Button, Input, Row, Preloader, Col } from 'react-materialize';
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ebook: `material-estudos/cpa10${props.path}`,
      error: false,
      isFetching: true,
      downloadList: [],
    };
  }

  componentDidMount() {
    let downloadList;
    switch (this.props.path) {
      case '/sistema-financeiro':
        downloadList = [
          {
            arquivo: 'material-estudos/cpa10/2022/CPA-10-Cap1.pdf',
            text: 'Baixar meu e-book',
          },
        ];
        break;
      case '/analise-do-perfil-investidor':
        downloadList = [
          {
            arquivo: 'material-estudos/cpa10/2022/CPA-10-Cap2.pdf',
            text: 'Baixar meu e-book',
          },
        ];
        break;
      case '/conceitos-basicos-economia-financas':
        downloadList = [
          {
            arquivo: 'material-estudos/cpa10/2022/CPA-10-Cap3.pdf',
            text: 'Baixar meu e-book',
          },
        ];
        break;
      case '/principios-de-investimento':
        downloadList = [
          {
            arquivo: 'material-estudos/cpa10/2022/CPA-10-Cap4.pdf',
            text: 'Baixar meu e-book',
          },
        ];
        break;
      case '/fundos-de-investimento':
        downloadList = [
          {
            arquivo: 'material-estudos/cpa10/2022/CPA-10-Cap5.pdf',
            text: 'Baixar meu e-book',
          },
        ];
        break;
      case '/renda-variavel-fixa':
        downloadList = [
          {
            arquivo: 'material-estudos/cpa10/2022/CPA-10-Cap6.pdf',
            text: 'Baixar meu e-book',
          },
        ];
        break;
      case '/previdencia':
        downloadList = [
          {
            arquivo: 'material-estudos/cpa10/2022/CPA-10-Cap7.pdf',
            text: 'Baixar meu e-book',
          },
        ];
        break;
      default:
        return null;
    }
    this.setState({ downloadList });
  }

  setName = (evento) => {
    this.props.handleName(evento.target.value);
  };

  setEmail = (evento) => {
    this.props.handleEmail(evento.target.value);
  };

  setCpfCnpj = (evento) => {
    this.props.handleCpfcnpj(evento.target.value);
  };

  handleSubscribe = (e) => {
    e.preventDefault();

    if (this.props.cpfcnpj.validCpf || this.props.cpfcnpj.validCnpj) {
      this.diferenciaCpfCnpj();
      this.props.setSubscribed(true);
    }
  };

  diferenciaCpfCnpj = () => {
    if (this.props.cpfcnpj.value.trim().length === 11) {
      // CPF
      this.props.handleCpf(this.props.cpfcnpj.value);
    } else if (this.props.cpfcnpj.value.trim().length === 14) {
      // CNPJ
      this.props.handleCnpj(this.props.cpfcnpj.value);
    }
  };

  sendForm = (e, _i) => {
    const requestConfig = {
      method: 'POST',
      body: JSON.stringify({
        name: this.props.name,
        email: this.props.email,
        cpf: this.props.cpf,
        cnpj: this.props.cnpj,
        ebook: this.state.ebook,
        arquivo: this.state.downloadList[_i].arquivo
      }),
      mode: 'cors',
      headers: { 'Content-type': 'application/json' },
    };

    this.setState({ isFetching: true });
    this.setState({ error: false });

    fetch(window.APP_GLOBAL_CONFIG.apiBaseUrl + '/download-url', requestConfig)
      .then(response => response.text())
      .then((url) => {
        this.setState({ isFetching: false });
        this.downloadFile(url);
      })
      .catch((error) => {
        this.setState({ error: true });
        this.setState({ isFetching: false });
        console.log('cath error', error);
      })
      .catch((error) => {
        this.setState({ error: true });
        this.setState({ isFetching: false });
        console.log('cath error 2', error);
      });
  };

  downloadFile = (url) => {
    const { path } = this.props;
    let isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (!isiOS) {
      // all devices, except iOS

      // montando o link
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', url);
      link.setAttribute('target', '_blank');
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // iOS
      var link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = `${path}.pdf`;

      var evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      link.dispatchEvent(evt);

      (window.URL || window.webkitURL).revokeObjectURL(link.href);
    }
  };

  renderCadastro = (cpfcnpj) => (
    <div className="content-change step-1">
      <Row className="formCpfCnpj">
        <Input
          className="cpf-cnpj"
          s={12}
          label="Digite seu CPF ou CNPJ"
          defaultValue={cpfcnpj.value}
          onChange={this.setCpfCnpj}
          validate
          required
          maxLength="14"
        />
        <div
          className={`resultadoValidacao ${
            cpfcnpj.validCpf || cpfcnpj.validCnpj ? 'success' : 'alert'
          }`}
          ref="resultadoValidacao"
        >
          {!!cpfcnpj.value.length && !cpfcnpj.validCpf && (
            <i className="fa fa-exclamation-circle">CPF inválido</i>
          )}

          {!!cpfcnpj.value.length && cpfcnpj.validCpf && <i className="fa fa-check">CPF válido</i>}
        </div>
      </Row>
      <Row>
        <Input
          s={12}
          label="Digite seu nome ou empresa"
          defaultValue={this.props.name}
          onChange={this.setName}
          validate
          required
        />
      </Row>
      <Row>
        <Input
          s={12}
          type="email"
          label="Digite seu e-mail"
          defaultValue={this.props.email}
          onChange={this.setEmail}
          validate
          required
        />
      </Row>
      <Row>
        <Button className="btn-large waves-effect waves-light" type="submit">
          Baixar
        </Button>
      </Row>
    </div>
  );

  renderLoading = () => {
    setTimeout(() => {
      this.setState({ isFetching: false });
    }, 1000);
    return (
      <div className="content-change step-2">
        <Row>
          <Col s={12}>
            <Preloader size="big" />
          </Col>
        </Row>
      </div>
    );
  };

  renderDownload = () => {
    const { downloadList } = this.state;
    return (
      <div className="content-change step-2 download">
        <div className="row">
          {downloadList.length > 1 && (
            <p className="warning warning--info">
              <b>ATENÇÃO</b>
              <br />
              Parte do conteúdo das provas mudará em janeiro. Por isso, disponibilizamos duas
              versões das apostilas dos módulos 1, 2 e 5.
            </p>
          )}
          <p>
            {downloadList.length > 1
              ? `Escolha qual arquivo gostaria de baixar:`
              : `Clique para baixar o E-book:`}
          </p>
        </div>
        {downloadList.map((_downloadList, _i) => (
          <button
            key={`${_i + 1}`}
            id="download-button"
            onClick={(e) => this.sendForm(e, _i)}
            className="btn-large waves-effect waves-light"
          >
            {_downloadList.text}
          </button>
        ))}
      </div>
    );
  };

  renderError = () => (
    <div className="content-change step-2">
      <p>Sistema temporariamente indisponível. Por favor, tente novamente mais tarde.</p>
    </div>
  );

  render() {
    const { cpfcnpj } = this.props;
    return (
      <form onSubmit={this.handleSubscribe}>
        <div className="titulo">Baixe o e-book gratuito!</div>
        <div>
          {!this.props.isSubscribed
            ? this.renderCadastro(cpfcnpj)
            : this.state.isFetching
            ? this.renderLoading()
            : this.state.error
            ? this.renderError()
            : this.renderDownload()}
          {/* {this.renderDownload()} */}
          <small>
            Estamos comprometidos em resguardar suas informações. Conheça nossa{' '}
            <a
              href="http://www.anbima.com.br/pt_br/politica-de-privacidade.htm"
              target="_blank"
              rel="noopener noreferrer"
            >
              Política de Privacidade
            </a>
          </small>
        </div>
      </form>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/Form.js